import { Component, EventEmitter, input, Input, OnChanges, Output } from '@angular/core';
import { TClassList } from '@core/helpers';
import { EIconPath } from '../../../shared/enums/icons.enum';

@Component({
  selector: 'pp-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false,
})
export class CheckboxComponent implements OnChanges {
  @Output() ppOnValueChange = new EventEmitter<void>();

  @Input() ppDisabled = false;
  @Input() ppChecked: boolean;
  @Input() ppSize: 'large' | 'medium' = 'large';
  @Input() ppType: 'solid' | 'subtle' = 'subtle';
  @Input() ppHalfChecked = false;
  @Input() ppId: string;
  @Input() ppIsLocked: boolean;
  @Input() ppAriaLabel: string;

  class: TClassList;
  EIconPath = EIconPath;
  src: EIconPath;

  ngOnChanges() {
    this.getClass();
    this.getSrc();
  }

  getSrc(): void {
    if (this.ppHalfChecked) {
      this.src =
        this.ppSize === 'large'
          ? EIconPath.ICON_INPUT_CHECKBOX_HALF_CHECK_18
          : EIconPath.ICON_INPUT_CHECKBOX_HALF_CHECK_12;
    } else {
      this.src =
        this.ppSize === 'large'
          ? EIconPath.ICON_INPUT_CHECKBOX_CHECK_18
          : EIconPath.ICON_INPUT_CHECKBOX_CHECK_12;
    }
  }

  private getClass(): void {
    if (this.ppDisabled || this.ppIsLocked) {
      this.class = this.getDisabledClass();
    } else {
      this.class = this.getActiveClass();
    }
  }

  private getActiveClass(): TClassList {
    return {
      'checkbox--solid': this.ppType === 'solid',
      'checkbox--subtle': this.ppType === 'subtle',
      'checkbox--large': this.ppSize === 'large',
      'checkbox--medium': this.ppSize === 'medium',
    };
  }

  private getDisabledClass(): TClassList {
    return {
      'checkbox--disabled': this.ppDisabled || this.ppIsLocked,
      'checkbox--solid': this.ppType === 'solid',
      'checkbox--subtle': this.ppType === 'subtle',
      'checkbox--large': this.ppSize === 'large',
      'checkbox--medium': this.ppSize === 'medium',
    };
  }

  toggleCheckbox(): void {
    if (!this.ppDisabled && !this.ppIsLocked) {
      this.ppOnValueChange.emit();
    }
  }
}
